import type { BackgroundValue } from '@elfsight/configurator-contracts';
import tinycolor from 'tinycolor2';

const DARK_COLOR = 'rgb(17, 17, 17)';
const LIGHT_COLOR = 'rgb(255, 255, 255)';

function calculateBrightness(color: string) {
  const { r, g, b } = tinycolor(color).toRgb();

  return 0.299 * r + 0.587 * g + 0.114 * b;
}

export function getInvertedColorFromBackground(background: BackgroundValue) {
  const { type, color, gradient, imageBrightness, videoBrightness } =
    background;

  if (type === 'image' && imageBrightness) {
    return imageBrightness <= 50 ? LIGHT_COLOR : DARK_COLOR;
  }

  if (type === 'video' && videoBrightness) {
    return videoBrightness <= 50 ? LIGHT_COLOR : DARK_COLOR;
  }

  if (type === 'gradient' && gradient) {
    const brightnessValues = gradient.colors.map(calculateBrightness);

    const averageBrightness =
      brightnessValues.reduce((a, b) => a + b, 0) /
      Math.max(brightnessValues.length, 1);

    return averageBrightness > 156 ? DARK_COLOR : LIGHT_COLOR;
  }

  if (type === 'color' && color && color !== 'transparent') {
    return calculateBrightness(color) > 156 ? DARK_COLOR : LIGHT_COLOR;
  }

  return DARK_COLOR;
}
